// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Organisatie.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const upgrade = [
    {
        type: InGameEffect.upgradeMechanic,
        description: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
    },
];
const newMechanic = [
    {
        type: InGameEffect.newMechanic,
        description: 'Zet een nieuwe monteur in op kennisniveau 1 (+500), 2 of 3 (-500)',
    },
];
export const OrganisatieTaken = [
    {
        _id: 'organisatie0',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 1500,
        description: 'Leid monteur op naar een hoger niveau',
        inGameEffectDescription: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: upgrade,
    },
    {
        _id: 'organisatie1',
        type: TaskType.organisatie,
        title: 'Monteur inhuren',
        cost: 2000,
        description: 'Neem een nieuwe monteur aan',
        inGameEffectDescription: 'Zet een nieuwe monteur in op kennisniveau 1 (+500), 2 of 3 (-500)',
        inGameEffect: [InGameEffect.newMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: newMechanic,
    },
    {
        _id: 'organisatie2',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 1500,
        description: 'Leid monteur op naar een hoger niveau',
        inGameEffectDescription: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: upgrade,
    },
    {
        _id: 'organisatie3',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 1500,
        description: 'Doe een Asset Management Serious Game met een monteur',
        inGameEffectDescription: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: upgrade,
    },
    {
        _id: 'organisatie4',
        type: TaskType.organisatie,
        title: 'Monteur inhuren',
        cost: 2000,
        description: 'Neem een nieuwe monteur aan',
        inGameEffectDescription: 'Zet een nieuwe monteur in op kennisniveau 1 (+500), 2 of 3 (-500)',
        inGameEffect: [InGameEffect.newMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: newMechanic,
    },
    {
        _id: 'organisatie5',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 1500,
        description: 'Leid Hoofd Technische Dienst op. Upgrade een monteur van kennisniveau 4 naar kennisniveau 5.',
        inGameEffectDescription: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeMechanic4to5],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: [
            {
                type: InGameEffect.upgradeMechanic4to5,
                description: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
            },
        ],
    },
    {
        _id: 'organisatie6',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 1500,
        description: 'Leid een monteur op naar een hoger niveau',
        inGameEffectDescription: 'Beweeg een monteur naar keuze, een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: upgrade,
    },
    {
        _id: 'organisatie7',
        type: TaskType.organisatie,
        title: 'Monteur inhuren',
        cost: 2000,
        description: 'Neem een nieuwe monteur aan',
        inGameEffectDescription: 'Zet een nieuwe monteur in op kennisniveau 1 (+500), 2 of 3 (-500)',
        inGameEffect: [InGameEffect.newMechanic],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: newMechanic,
    },
    {
        _id: 'organisatie8',
        type: TaskType.organisatie,
        title: 'Monteur opleiden',
        cost: 4000,
        description: 'De meestermonteur verzorgt een opleiding voor alle monteurs',
        inGameEffectDescription: 'Beweeg alle monteurs een kennisniveau omhoog',
        inGameEffect: [InGameEffect.upgradeAllMechanics],
        needsSparepart: false,
        needsMechanic: true,
        levelMechanicNeeded: 5,
        taskEffects: [
            {
                type: InGameEffect.upgradeAllMechanics,
                description: 'Beweeg alle monteurs een kennisniveau omhoog',
            },
        ],
    },
];
/** Het kennisniveau van de topmonteur van het uitzendbureau. */
export const TOPMONTEUR_NIVEAU = 4;
/**
 * Niet in het origineel: de kaart die het team krijgt als Amanda van HR belt over een
 * goede monteur via een uitzendbureau (`kaart` bij die stakeholder). Hij zit niet in de
 * stapel Organisatie: na het spelen komt er geen kaart voor terug.
 */
export const topmonteurTaak = {
    _id: 'organisatieTopmonteur',
    type: TaskType.organisatie,
    title: 'Topmonteur inhuren',
    cost: 2000,
    description: 'De topmonteur van het uitzendbureau. Alleen deze ronde beschikbaar!',
    inGameEffectDescription: `Zet een nieuwe monteur in op kennisniveau ${TOPMONTEUR_NIVEAU}. Je budget per week blijft gelijk.`,
    inGameEffect: [InGameEffect.newTopMechanic],
    needsSparepart: false,
    needsMechanic: false,
    taskEffects: [
        {
            type: InGameEffect.newTopMechanic,
            description: `Zet een nieuwe monteur in op kennisniveau ${TOPMONTEUR_NIVEAU}. Je budget per week blijft gelijk.`,
        },
    ],
};
